import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import type { UserRole } from "./types/notification.types";
import CSCAlerts from "./components/CSCAlerts";

interface NotificationProps {
  role?: UserRole;
}

interface LayoutContext {
  setCrumbs?: (crumbs: { label: string; link?: string }[]) => void;
}

export default function Notification({ role = "Admin" }: NotificationProps) {
  const ctx = useOutletContext<LayoutContext>();

  useEffect(() => {
    const homeLink =
      role === "Inspector"
        ? "/project-inspection"
        : role === "Owner"
          ? "/owner-dashboard"
          : "/bank-dashboard";
    const homeLabel =
      role === "Inspector" ? "Field Inspection" : "My Projects";
    ctx?.setCrumbs?.([
      { label: homeLabel, link: homeLink },
      { label: "Notifications" },
    ]);
  }, [role]);

  return <CSCAlerts role={role} />;
}
